import type { components } from "./api-types.gen";

/**
 * An operation of the rights matrix ([F-027]). The server decides every one;
 * the SPA never mirrors the matrix. What it shows is what the server says the
 * caller may do: `/me.can` for operations without an object (create, export,
 * master data, DSGVO), the `can` of an incident, list row or follow-up task
 * for operations on that object.
 */
export type Operation = components["schemas"]["Operation"];

/** Anything the server answered `can` for: the session user, an incident, a task. */
export interface CanHolder {
  can: readonly Operation[];
}

/** May the caller perform `op` on this subject, as the server answered? */
export function may(subject: CanHolder | null | undefined, op: Operation): boolean {
  return subject?.can.includes(op) ?? false;
}

/** The roles [F-004] admits as Owner or Bearbeiter of an incident. */
const INCIDENT_PARTY_ROLES = ["incident_owner", "bearbeiter"];

/**
 * May this person be named Owner or Bearbeiter ([F-004])? A picker shows the
 * others disabled, with the reason, instead of hiding them - so the refusal
 * [AC-004] describes stays reachable and visible. The server re-checks.
 */
export function isIncidentParty(user: { active: boolean; roles: readonly string[] }): boolean {
  return user.active && user.roles.some((role) => INCIDENT_PARTY_ROLES.includes(role));
}
